import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function Casestudy() {
  return (
  <Box sx={{px: { xs: 2, sm: 4, md: 6, lg: 10, xl: 22 }, py: 8,  mx: "auto" }}>
      <Box sx={{ flex: 1, position: "sticky", top: 100 }}>
        <Typography
          variant="caption"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "#fff",
            px: 2,
            borderRadius: 10,
            border : "1px solid rgb(165, 165, 165)",
            fontWeight: 600,
            gap: 0.5,
            py: 0.5
          }}
        >
          <VisibilityIcon sx={{ fontSize: 16, color: "blue" }} />
          Case study
        </Typography>

        {/* Heading and Button in one row - Opposite ends */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            flexWrap: "wrap", // Optional: handles mobile wrap
            gap: 2
          }}
        >
          <Typography variant="h4" fontWeight="bold"
          sx={{
            fontFamily : "Aeonik-bold, sans-serif",
           fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },

          }}>
            Our Products
          </Typography>

          {/* <Button
           sx={{
                position : "relative",
                overflow: "hidden",
                backgroundColor: "#032262",
                color: "white",
                px: { xs: 4, md: 4 },
                py: { xs: 1.5, md: 1 },
                fontSize: { xs: "0.85rem", md: "1.2rem" },
                fontFamily : "Aeonik-bold, sans-serif",
                textTransform: "none",
               zIndex : 1,
               "&:before": {
                content: "''",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#a10304",
                transform: "translateY(100%)",
                transition: "transform 0.3s ease",
                zIndex: -1
               },
               "&:hover:before": {
                transform: "translateY(0)",
               },
               "&:hover": {
                color: "white",
               }
}}
          >
            View more services
          </Button> */}
        </Box>
      </Box>
    </Box>
  );
}
